export const WEEKDAYS = {
    Monday: 'Maandag',
    Tuesday: 'Dinsdag',
    Wednesday: 'Woensdag',
    Thursday: 'Donderdag',
    Friday: 'Vrijdag',
    Saturday: 'Zaterdag',
    Sunday: 'Zondag',
}

export const AVAILABLE_STATUS = {
    1: 'Open',
    0: 'Gesloten',
}
